module.exports = __webpack_public_path__ + "img/b_03.3ccf5e0c.png";